import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { CreateOrderComponent } from '@shared/components/trading/orders/create-order/create-order.component'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'

@Component({
	selector: 'app-create-order-widget',
	templateUrl: './create-order-widget.component.html',
	imports: [CreateOrderComponent],
	styleUrl: './create-order-widget.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateOrderWidgetComponent {
	@Input() widget: WidgetInterface | null = null
}
